export default function getRelativePath(href) {
    const { pathname, search, hash } = new URL(href);
    return pathname + search + hash;
}
//# sourceMappingURL=getRelativePath.js.map